import { useState } from "react";
import useSyncDataset from "admin/components/dataset-detail/hooks/useSyncDataset";
import { ComponentType, SyncOptions } from "admin/components/dataset-detail/types/dataset-diff";
import { Button } from "~/components/ui/button";
import { Checkbox } from "~/components/ui/checkbox";
import { Label } from "~/components/ui/label";

interface SyncControlsProps {
  onSyncComplete: () => void;
}

const SyncControls = ({ onSyncComplete }: SyncControlsProps) => {
  const [syncTables, setSyncTables] = useState(false);
  const [syncFiles, setSyncFiles] = useState(false);
  const [syncReports, setSyncReports] = useState(false);
  const [syncSchemas, setSyncSchemas] = useState(false);
  const [syncAccessLevels, setSyncAccessLevels] = useState(false);

  const { syncDataset, isSyncing } = useSyncDataset();

  const hasSelection = syncTables || syncFiles || syncReports || syncSchemas || syncAccessLevels;

  const handleSync = async () => {
    const componentTypes: ComponentType[] = [];
    if (syncTables) componentTypes.push("table");
    if (syncFiles) componentTypes.push("file");
    if (syncReports) componentTypes.push("report");
    if (syncSchemas) componentTypes.push("schema");

    const options: SyncOptions = {
      sync_component_types: componentTypes,
      sync_access_levels: syncAccessLevels,
    };

    const success = await syncDataset(options);

    if (success) {
      setSyncTables(false);
      setSyncFiles(false);
      setSyncReports(false);
      setSyncSchemas(false);
      setSyncAccessLevels(false);
      onSyncComplete();
    }
  };

  return (
    <div className="pt-4 border-t border-border">
      <div className="flex flex-col gap-4">
        <div className="flex items-center gap-6">
          <div className="flex items-center gap-2">
            <Checkbox
              id="sync-tables"
              checked={syncTables}
              onCheckedChange={(v) => setSyncTables(!!v)}
              disabled={isSyncing}
            />
            <Label htmlFor="sync-tables">Sync Tables</Label>
          </div>
          <div className="flex items-center gap-2">
            <Checkbox
              id="sync-files"
              checked={syncFiles}
              onCheckedChange={(v) => setSyncFiles(!!v)}
              disabled={isSyncing}
            />
            <Label htmlFor="sync-files">Sync Files</Label>
          </div>
          <div className="flex items-center gap-2">
            <Checkbox
              id="sync-reports"
              checked={syncReports}
              onCheckedChange={(v) => setSyncReports(!!v)}
              disabled={isSyncing}
            />
            <Label htmlFor="sync-reports">Sync Reports</Label>
          </div>
          <div className="flex items-center gap-2">
            <Checkbox
              id="sync-schemas"
              checked={syncSchemas}
              onCheckedChange={(v) => setSyncSchemas(!!v)}
              disabled={isSyncing}
            />
            <Label htmlFor="sync-schemas">Sync Schemas</Label>
          </div>
          <div className="flex items-center gap-2">
            <Checkbox
              id="sync-access-levels"
              checked={syncAccessLevels}
              onCheckedChange={(v) => setSyncAccessLevels(!!v)}
              disabled={isSyncing}
            />
            <Label htmlFor="sync-access-levels">Sync Access Levels</Label>
          </div>
        </div>

        <div>
          <Button variant="destructive" onClick={handleSync} disabled={!hasSelection || isSyncing}>
            {isSyncing ? "Syncing..." : "Sync Dataset"}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default SyncControls;
